export default __webpack_public_path__ + "static/media/driver_blue.f3f6e893.svg";